import * as Effect from "effect/Effect";
//#region src/extensions/stub.ts
var stubExtension = {
	initialize: () => Effect.succeed(void 0),
	enable: () => Effect.succeed(void 0),
	disable: () => Effect.succeed(void 0),
	flush: () => Effect.succeed(void 0),
	setTags: () => void 0,
	get enabled() {
		return true;
	},
	apis: []
};
//#endregion
export { stubExtension as t };

//# sourceMappingURL=chunk-stub.mjs.map